import { Box } from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Prefectures, Status } from "../../assets/data/Constants";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import TkStepper from "../../components/atoms/TkStepper";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkDateDialog from "../../components/molecules/TkDateDialog";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import { BusinessContext } from "../../context/businessContext";
import { GlobalContext } from "../../context/globalContext";
import { TkGetCode } from "../../utils/TkGetCode";
import "./_style.scss";
import { httpIAPI_FAC012, httpIAPI_FAC026 } from "./api/request";
import { fakeTableList, schema, stepper } from "./parts";
import _ from "lodash";
/**
 * SCRC050018 施設転換後非加入　新規登録
 * @return SCRC050018 施設転換後非加入　新規登録
 */
const SCRC050018 = () => {
  const navigate = useNavigate();
  let location = useLocation();
  const locationState = location.state;
  const [stateInfoList, setStateInfoList] = useState<any>([]);
  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));
  // 認証情報
  const { state, setState } = useContext(GlobalContext);
  // 持回情報
  const { state: businessState } = useContext(BusinessContext);
  // ユーザタイプ
  const userType = state.authInfo?.userType;
  // ユーザタイプが機構か
  const isUserTypeKiko = userType === authorityUserType.userTypeNumber.KIKO;

  // ユーザタイプが契約者か
  const isUserTypeKeiyakusya =
    userType === authorityUserType.userTypeNumber.KEIYAKUSYA;
  // 契約者番号
  const contractorNo = businessState.common?.contractorNo;
  // 申請ID
  const applyId = locationState?.applyId;

  const [applyIdState, setApplyIdState] = useState<number | undefined>();

  // ダイアログ開閉状態
  const [isOpenMsgDialog, setIsOpenMsgDialog] = useState<boolean>(false);

  // ステッパー
  const [step, setStep] = useState(0);
  // ボタン表示
  const [showButton, setShowButton] = useState(true);

  const submitRef = useRef<any>();

  const handleInit = async () => {
    let resArr = stateFakeTableList.current;
    // 契約者（法人）名
    if (isUserTypeKiko) {
      let contractorName = resArr.find(
        (item) => item.keyword === "contractorName"
      )!;
      contractorName.showLine = true;
      contractorName.text =
        contractorNo + ":" + businessState.common?.contractorName;
      let title = resArr.find((item) => item.keyword === "title")!;
      title.showLine = true;
    }

    try {
      const res = await httpIAPI_FAC026({
        applyId: applyId ?? 0,
        contractorNo: isUserTypeKiko
          ? businessState?.common?.contractorNo
          : state?.authInfo?.contractorNo,
      });

      if (res.resultCd === "I0000") {
        // 初期表示
        // 転換予定日
        resArr.find(
          (item) => item.keyword === "changeoverDueDate"
        )!.setDefaultValue = res["changeoverDueDate"];
        // 施設名
        resArr.find(
          (item) => item.keyword === "bFacilityName"
        )!.selectPropsList = [
          {
            value: res?.bFacilityNo,
            label: res?.bFacilityNo + ":" + (res?.bFacilityName ?? ""),
          },
        ];
        resArr.find(
          (item) => item.keyword === "bFacilityName"
        )!.setDefaultValue = res["bFacilityNo"];
        // 転換前施設種類
        resArr.find(
          (item) => item.keyword === "bFacilityKind"
        )!.setDefaultValue = res["bFacilityKindName"];
        // 転換前施設所在地郵便番号
        resArr.find(
          (item) => item.keyword === "bFacilityZipcode"
        )!.setDefaultValue = res["bFacilityZipcode"];
        // 転換前施設所在地
        if (
          res.bFacilityPrefectureCd !== undefined &&
          !isNaN(Number(res.bFacilityPrefectureCd))
        ) {
          const resObj: any = {
            prefectures: TkGetCode(Prefectures, res.bFacilityPrefectureCd),
            city: res.bFacilityAddressCity,
            address: res.bFacilityAddressOthers,
          };

          resArr.find(
            (item) => item.keyword === "bFacilityAddress"
          )!.valueObject = resObj;
        }
        // 転換後施設名称
        resArr.find(
          (item) => item.keyword === "aFacilityName"
        )!.setDefaultValue = res["aFacilityName"];
        // 転換前施設種類
        resArr.find(
          (item) => item.keyword === "aFacilityKind"
        )!.setDefaultValue = res["aFacilityKindName"];
        // 転換前施設所在地郵便番号
        resArr.find(
          (item) => item.keyword === "aFacilityZipcode"
        )!.setDefaultValue = res["aFacilityZipcode"];
        // 転換前施設所在地
        if (
          res.aFacilityPrefectureCd !== undefined &&
          !isNaN(Number(res.aFacilityPrefectureCd))
        ) {
          const resObj: any = {
            prefectures: TkGetCode(Prefectures, res.aFacilityPrefectureCd),
            city: res.aFacilityAddressCity,
            address: res.aFacilityAddressOthers,
          };

          resArr.find(
            (item) => item.keyword === "aFacilityAddress"
          )!.valueObject = resObj;
        }

        // 備考
        const remark = resArr.find((item) => item.keyword === "remark")!;
        remark.setDefaultValue = res["remark"];

        const excludedStatuses = [Status["届出待ち"], Status["差戻し一時保存"]];
        if (!excludedStatuses.includes(res.latestApplyStatus as Status)) {
          setStep(1);
          setShowButton(false);
          remark.disabled = true;
        } else {
          setStep(0);
          setShowButton(true);
        }
        setApplyIdState(res?.applyId);

        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setShowButton(false);
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }

      setStateInfoList([...resArr]);
    } catch {
      navigate("/error");
    }
  };

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onCheckAndSubmit = async (data: any) => {
    submitRef.current = data;
    setIsOpenMsgDialog(true);
  };

  const handleSubmit = async (date?: any) => {
    try {
      const res = await httpIAPI_FAC012({
        contractorNo: isUserTypeKiko
          ? businessState?.common?.contractorNo
          : state?.authInfo?.contractorNo,
        applyId: applyIdState,
        receptionDate: date,
        remark: submitRef.current.remark,
      });

      if (res?.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRC070008");
      } else {
        setState({
          ...state,
          errorMsgId: res?.resultCd,
        });
        setIsOpenMsgDialog(false);
      }
    } catch {
      navigate("/error");
    }
  };

  return (
    <Box className="SCRC050018" data-testid="SCRC050018PageForTest">
      <TkStepper steps={stepper} activeStep={step} />
      <TkInfoManual rule={"\\n"}>{labelids.labelid.LBLC050018_01}</TkInfoManual>
      <TkFakeTable
        list={stateInfoList}
        ruleSchema={schema}
        onCheckAndSubmit={onCheckAndSubmit}
        buttonGroup={<TkBackButton />}
        submitButtonText={
          isUserTypeKiko
            ? "申請"
            : isUserTypeKeiyakusya
            ? "機構へ提出する"
            : undefined
        }
        showButton={showButton}
      />

      {isUserTypeKiko ? (
        <TkDateDialog
          open={isOpenMsgDialog}
          onOky={handleSubmit}
          onCancel={() => setIsOpenMsgDialog(false)}
          minDate={new Date("1900/01/01")}
          maxDate={new Date()}
          title="確認（申請）"
          contextText="　申請を行いますが、問題ないでしょうか。"
          cancelText="いいえ"
          okText="はい"
        />
      ) : (
        <TkMessageDialog
          open={isOpenMsgDialog}
          onOky={handleSubmit}
          onCancel={() => setIsOpenMsgDialog(false)}
          title="確認（機構へ提出します）"
          contextText="　機構へ提出を行いますが、問題ないでしょうか。"
          cancelText="いいえ"
          okText="はい"
        />
      )}
    </Box>
  );
};

export default SCRC050018;
